import { defineComponent as $, ref as A, computed as F, resolveComponent as L, createElementBlock as s, createCommentVNode as u, openBlock as n, withDirectives as d, withModifiers as f, normalizeClass as w, unref as a, createBlock as v, createElementVNode as x, toDisplayString as O, Fragment as I, createVNode as _, normalizeStyle as X, renderList as j, vShow as G } from "vue";
import J from "./TruncatedText.js";
import "./CommentTileCore.vue_vue_type_style_index_0_scoped_db29f5cd_lang-BGz-jqNx.js";
import { t as K } from "./tooltip-YeSRTnG0.js";
/* empty css                                                                      */
/* empty css                                                                        */
import { o as Q } from "./index-DA7LeYY4.js";
/* empty css                                                                      */
import R from "./SvgRender.js";
import "./icon-C5cGsR9k.js";
import { _ as g } from "./Icon.ce.vue_vue_type_script_setup_true_lang-CdOC0ycX.js";
/* empty css                                                                  */
import "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import "./OverflowTooltip.js";
/* empty css                                                                    */
import "./Chip.js";
import "./idb-35dVPy4g.js";
/* empty css                                                                  */
import "./main-Bh5cSLmY.js";
/* empty css                                                          */
import "./debounce-BJrVv5jG.js";
/* empty css                                                                     */
/* empty css                                                                    */
import "./SearchInput.js";
import "./LoadMoreWrapper.js";
import "./Select-Dbr2pXH_.js";
/* empty css                                                                         */
/* empty css                                                                            */
import "./StatusSelect.js";
/* empty css                                                                      */
/* empty css                                                                */
import "./Reaction.vue_vue_type_style_index_0_scoped_a67a1bb4_lang-WDRHCN3u.js";
/* empty css                                                                     */
/* empty css                                                                           */
/* empty css                                                                        */
/* empty css                                                               */
/* empty css                                                                */
/* empty css                                                                          */
import { u as U } from "./usePositioning-DoUl_PGT.js";
/* empty css                                                                      */
/* empty css                                                                        */
/* empty css                                                                */
/* empty css                                                                        */
/* empty css                                                                     */
/* empty css                                                        */
/* empty css                                                                        */
/* empty css                                                                            */
/* empty css                                                                            */
/* empty css                                                                     */
/* empty css                                                                      */
/* empty css                                                                            */
import "./MainCalendar.js";
import "./CalendarNavigationControl.js";
/* empty css                                                                          */
/* empty css                                                                  */
/* empty css                                                                       */
/* empty css                                                                   */
/* empty css                                                  */
import "./js.cookie-CA0diDCW.js";
import "./fileManager-BNE_Afa-.js";
import "pinia";
/* empty css                                                                        */
import "./CommentUploadFile.ce.vue_vue_type_script_lang-Bi4IeKWp.js";
import { _ as W } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const Y = { class: "menu-action-item--label" }, Z = {
  key: 2,
  class: "confirm-icon"
}, ee = { class: "confirm-icon__button confirm-icon__button--cancel" }, te = ["onClick"], oe = /* @__PURE__ */ $({
  __name: "MenuActionItem",
  props: {
    data: {},
    layer: {},
    direction: {}
  },
  emits: ["hide"],
  setup(h, { emit: S }) {
    const b = K, t = h, p = S, { opened: y, targetRef: B, popoverRef: T, openMenu: q, hideMenu: m, toggleMenu: D, computedStylePopover: N, position: P } = U(() => {
    }, !0), V = (i, o) => {
      function c(e) {
        e.action && e.action(o), m(), p("hide");
      }
      i.confirm ? r.value = !0 : i.subMenu && i.subMenu.length > 0 ? D() : c(i);
    }, M = A(null), r = A(!1);
    Q(M, () => {
      r.value && (r.value = !1);
    });
    const C = (i, o, c) => {
      if (t.data.disabled)
        return;
      switch (!0) {
        case (o.confirm && r.value && c === !1):
          e(o, i);
          break;
        case (o.confirm && r.value && c === !0):
          r.value = !1;
          break;
        case (o.confirm && r.value === !1 && c === !0):
          r.value = !0;
          break;
        case (o.subMenu && o.subMenu.length > 0):
          k();
          break;
        default:
          e(o, i), o.preventClose || (m(), p("hide"));
          break;
      }
      function e(z, H) {
        z.action && z.action(H), m(), p("hide");
      }
      function k() {
        y.value ? m() : q();
      }
    }, l = F(() => t.data.subMenu?.filter((i) => i.visible !== !1)), E = () => {
      m(), p("hide");
    };
    return (i, o) => {
      const c = L("MenuActionItem", !0);
      return t.data.visible !== !1 ? (n(), s("div", {
        key: 0,
        ref_key: "targetRef",
        ref: B,
        class: "menu-action-item"
      }, [
        d((n(), s("button", {
          class: w(["action-item-button", {
            active: a(y) || r.value,
            "has-confirm": t.data.confirm && r.value,
            danger: t.data.type == "danger",
            "has-icon": !!t.data.icon,
            "has-sub-menu": l.value && l.value.length > 0,
            disabled: t.data.disabled
          }]),
          onClick: o[2] || (o[2] = f((e) => C(e, t.data, !0), ["stop", "prevent"]))
        }, [
          t.data.icon ? (n(), v(a(g), {
            key: 0,
            class: "icon",
            name: t.data.icon,
            size: 20,
            color: t.data.type == "danger" ? "red" : "black",
            "is-square-size": ""
          }, null, 8, ["name", "color"])) : u("", !0),
          x("div", Y, O(t.data.label), 1),
          t.data.type == "submenu" ? (n(), s(I, { key: 1 }, [
            l.value && l.value.length > 0 ? (n(), v(a(g), {
              key: 0,
              class: "icon",
              name: "Play",
              size: 20,
              "is-square-size": ""
            })) : u("", !0)
          ], 64)) : t.data.confirm && r.value ? (n(), s("div", Z, [
            d((n(), s("button", ee, [
              _(R, {
                name: "Xmark",
                size: "16",
                color: "red",
                onClick: o[0] || (o[0] = f((e) => r.value = !1, ["stop"]))
              })
            ])), [
              [a(b), { content: "Cancel", delay: [300, 0] }]
            ]),
            d((n(), s("button", {
              ref_key: "confirmBtnRef",
              ref: M,
              class: "confirm-icon__button confirm-icon__button--confirm"
            }, [
              _(R, {
                name: "Check",
                size: "16",
                color: "red",
                onClick: o[1] || (o[1] = f((e) => C(e, t.data, !1), ["stop", "prevent"]))
              })
            ])), [
              [a(b), { content: "Confirm", delay: [300, 0], theme: "warning" }]
            ])
          ])) : u("", !0)
        ], 2)), [
          [a(b), {
            content: t.data.tooltip,
            delay: [300, 0],
            theme: t.data.type == "danger" ? "warning" : "arbo"
          }]
        ]),
        d(x("div", {
          ref_key: "popoverRef",
          ref: T,
          class: "action-sub-menu",
          style: X({ ...a(N), zIndex: t.layer })
        }, [
          l.value && l.value.length > 0 ? (n(!0), s(I, { key: 0 }, j(l.value, (e) => (n(), s("div", {
            key: e.id
          }, [
            e.subMenu && e.subMenu.length > 0 ? (n(), v(c, {
              key: 0,
              data: e,
              layer: h.layer + 1,
              direction: a(P),
              onHide: E
            }, null, 8, ["data", "layer", "direction"])) : (n(), s("button", {
              key: 1,
              class: w(["action-item-button", { danger: e.type == "danger", "has-icon": e.icon }]),
              onClick: f((k) => V(e, k), ["stop"])
            }, [
              e.icon ? (n(), v(a(g), {
                key: 0,
                class: "icon",
                name: e.icon,
                size: 20,
                color: e.type == "danger" ? "red" : "black",
                "is-square-size": ""
              }, null, 8, ["name", "color"])) : u("", !0),
              _(J, {
                value: e.label,
                truncate: "end"
              }, null, 8, ["value"])
            ], 10, te))
          ]))), 128)) : u("", !0)
        ], 4), [
          [G, a(y)]
        ])
      ], 512)) : u("", !0);
    };
  }
}), dt = /* @__PURE__ */ W(oe, [["__scopeId", "data-v-2d7560de"]]);
export {
  dt as default
};
